export enum ProjectType {
  RoutePlanning = 'route_planning',
  Accounting = 'accounting',
}
